// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateCustomGatewaySetting_createButton__EFJD6"};